import { EnvironmentProviders, Injectable, Provider } from "@angular/core"
import { CustomersRoutesProvider } from "./lib/routes/customers.routes"

@Injectable({ providedIn: 'root' })
export class CustomersConfigService {
    constructor() {}
}

export const provideCustomers = (): Array<Provider | EnvironmentProviders> => {
    return [
        { provide: CustomersRoutesProvider.getToken(), useClass: CustomersRoutesProvider, multi: true },
    ];
}